// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"UserLeaveManagement_overlayWrapper__JvLHz","viewBox":"UserLeaveManagement_viewBox__nvh9Y"};